import { apiAbortController } from '@ui/src';
import api from '../../../api/api';
import { Banks } from '../types';

export const banksApi = api.injectEndpoints({
  endpoints: (build) => ({
    getBanksReport: build.query<{ data: Banks }, string>({
      query: (query) => ({
        url: `/v1/reports/banks${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),

    exportBanksReport: build.mutation<
      any,
      { createdAtFrom?: string; createdAtTo?: string }
    >({
      query: (body) => ({
        url: '/v1/reports/banks/export',
        method: 'POST',
        body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    exportBanksReportWithAccounts: build.mutation<
      any,
      { createdAtFrom?: string; createdAtTo?: string }
    >({
      query: (body) => ({
        url: '/v1/reports/banks/accounts/export',
        method: 'POST',
        body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useExportBanksReportMutation,
  useLazyGetBanksReportQuery,
  useExportBanksReportWithAccountsMutation,
} = banksApi;

export const {
  endpoints: {
    getBanksReport,
    exportBanksReport,
    exportBanksReportWithAccounts,
  },
} = banksApi;
